import { reportError } from './errorReporting'

/**
 * Set up Vue error handlers
 * Note: Sentry's Vue integration already handles most Vue errors automatically,
 * but we keep these handlers for additional context and console logging
 */
export const setupVueErrorHandler = (app) => {
  // Global error handler for Vue component errors
  app.config.errorHandler = (err, instance, info) => {
    console.error('[Vue Error]', err, info)

    const context = {
      type: 'vue-component-error',
      componentName: instance?.$options?.name || 'Unknown',
      info
    }

    reportError(err, context)
  }

  // Global warning handler (optional, useful for development)
  app.config.warnHandler = (msg, _instance, trace) => {
    // Only log warnings in development, don't report them
    if (import.meta.env.DEV) {
      console.warn('[Vue Warning]', msg, trace)
    }
  }

  console.log('[Vue Error Handler] Initialized')
}
